const BookTitle = ({ title }) => {
  return <div className="book-title">{title}</div>;
};

export default BookTitle;
